<template>
  <div id="voucher-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <form class="formData-form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-3"></div>
              <div class="col-md-3"></div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">ADD/EDIT EXPERIENCE BOOST</h1>
            <fieldset>
              <div class="form-group row">
                <label for="title" class="form-label col-md-2">NAME</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    v-model="formData.title"
                    required
                    placeholder="Add a name for this experience boost (this is not public)"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="form-label col-md-2"
                  >Description</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="description"
                    rows="4"
                    v-model="formData.description"
                    placeholder="You can put your personal description here (this is not public)"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="terms" class="form-label col-md-2">Listing*</label>
                <div class="col-md-10">
                  <select
                    class="form-control"
                    id="country"
                    v-model="formData.listing"
                    required
                  >
                    <option>Pick one of your listings</option>
                  </select>
                  <div class="invalid-feedback">Pick one of your listings</div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-2"></div>
                <div class="col-md-10">
                  <div class="boost-input">
                    <input
                      type="checkbox"
                      :checked="value"
                      id="isAcceptedEnwokeAgreement"
                    />
                    Boost the positioning of the listing
                    <br />
                    <input
                      type="checkbox"
                      :checked="value"
                      id="isAcceptedEnwokeAgreement"
                    />
                    Boost the positioning of content connected to the listing
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Distribution</legend>
              <PlatformPicker v-model="formData.platforms" />
            </fieldset>
            <fieldset>
              <legend>Target Group*</legend>
              <TravelerTypePicker v-model="formData.travelerTypes" />
            </fieldset>
            <fieldset>
              <TypeBoostFieldset />
            </fieldset>
            <fieldset>
              <ScheduleBoostFieldset />
            </fieldset>
            <fieldset>
              <BoostBudgetFieldset :typeBudget="'BOOST'" />
            </fieldset>
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save &amp; Publish"
                  @click="onSaveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onUnpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onSaveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangeControl from "@/components/DateRangeControl";
import TravelerTypePicker from "@/components/TravelerTypePicker";
import ExperiencePicker from "@/components/ExperiencePicker";
import PlatformPicker from "@/components/PlatformPicker";
import BoostBudgetFieldset from "@/components/BoostBudgetFieldset";
import TypeBoostFieldset from "@/components/TypeBoostFieldset";
import ScheduleBoostFieldset from "@/components/ScheduleBoostFieldset";

import _ from "lodash";

export default {
  name: "VoucherForm",
  components: {
    TravelerTypePicker,
    ExperiencePicker,
    PlatformPicker,
    BoostBudgetFieldset,
    TypeBoostFieldset,
    ScheduleBoostFieldset,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      id: null,
      regions: [],
      districts: [],
      formData: {
        title: "",
        description: "",
        terms: "",
        publishStartDate: "",
        publishEndDate: "",
        usageStartDate: "",
        usageEndDate: "",
        quantity: "",
        price: "",
        priceCurrency: "USD",
        value: "",
        bookingUrl: "",
        bookingEmail: "",
        categories: [],
        travelerTypes: [],
        mainImageUrl: "",
        thumbnailUrl: "",
        country: null,
        region: null,
        district: null,
        experiences: [],
        platforms: [],
        isAcceptedEnwokeAgreement: false,
        status: "PUBLISH",
      },
    };
  },
  computed: {
    discountPercent() {
      const price = Number(this.formData.price);
      const value = Number(this.formData.value);
      return !Number.isNaN(price) &&
        !Number.isNaN(value) &&
        price > 0 &&
        value > 0
        ? 100 - Math.round((price / value) * 100)
        : "xx";
    },
  },
  mounted() {
    if (this.content) {
      this.prepare(this.content);
    }
  },
  methods: {
    prepare(content) {
      const formData = _.merge({}, content); // Create a copy.
      if (formData.experiences && formData.experiences.results) {
        formData.experiences = formData.experiences.results;
      }
      if (formData.travelerTypes && formData.travelerTypes.length > 0) {
        formData.travelerTypes = formData.travelerTypes.map((it) => it.id);
      }
      if (formData.platforms && formData.platforms.length > 0) {
        formData.platforms = formData.platforms.map((it) => it.id);
      }
      this.formData = formData;
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    onSaveAndPublish(ev) {
      this.save("PUBLISH");
    },
    onSaveDraft() {
      this.save("DRAFT");
    },
    onUnpublish() {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH") {
      if (!this.formData.isAcceptedEnwokeAgreement) return;

      this.formData.status = status;

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.mainImageUrl = files[0].url;
        this.formData.thumbnailUrl = files[0].url;
      }

      let promise = null;
      let saveData = _.merge({}, this.formData); // Clone data for saving.

      // Re-shape experience for saving.
      if (saveData.experiences && saveData.experiences.length > 0) {
        saveData.experiences = saveData.experiences.map((it) => it.id);

        saveData.country = null;
        saveData.region = null;
        saveData.district = null;
      }

      saveData.quantity = Number.parseInt(saveData.quantity);
      saveData.price = Number.parseFloat(saveData.price);
      saveData.value = Number.parseFloat(saveData.value);
      saveData.priceCurrency = saveData.priceCurrency || "USD";

      if (this.formData.id) {
        promise = this.$repo.voucher.updateVoucher(saveData);
      } else {
        promise = this.$repo.voucher.createVoucher(saveData);
      }

      promise
        .then((experience) => {
          this.$toasted.show("Save data successfully.", {
            type: "success",
            duration: 3000,
            position: "bottom-right",
          });
          this.closeForm();
        })
        .catch((err) => {
          console.error(err);
          this.$toasted.show("Something went wrong.", {
            type: "error",
            duration: 3000,
            position: "bottom-right",
          });
        });
    },
    async onDelete() {
      if (this.formData.id) {
        this.$repo.voucher.deleteVoucher(this.formData.id);
      }
      this.closeForm();
    },
    onClearUploadImage() {
      this.formData.mainImageUrl = "";
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
    async onCountryChanged() {
      // Reset data if is in creation mode.
      if (!this.id) {
        this.formData.region = null;
        this.formData.district = null;
      }
      this.regions = [];
      this.districts = [];

      const countryId = this.formData.country;
      if (!countryId) return;

      this.regions = await this.$repo.ref.getLocationsByParentId(countryId);

      if (this.regions && this.regions.length > 0) {
        this.formData.region = this.regions[0].id;
      }
      this.onRegionChanged({ target: { value: this.formData.region } });
    },
    async onRegionChanged(e) {
      // Reset data if is in creation mode.
      if (!this.id) {
        this.formData.district = null;
      }
      this.districts = [];

      const regionId = e.target.value;
      if (!regionId) return;

      this.districts = await this.$repo.ref.getLocationsByParentId(regionId);

      if (this.districts && this.districts.length > 0) {
        this.formData.district = this.districts[0].id;
      }
    },
    async validateLocation() {
      const countryId = this.formData.country;
      if (!countryId) return;

      this.regions = await this.$repo.ref.getLocationsByParentId(countryId);

      const regionId = this.formData.region;
      if (!regionId) return;

      this.districts = await this.$repo.ref.getLocationsByParentId(regionId);
    },
  },
};
</script>

<style lang="scss">
$main-color: #93014a;

#voucher-form {
  .form-title {
    color: $main-color;
  }

  .or {
    position: relative;
    top: -35px;
    margin-right: -10px;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  #experience-form .form-title {
    color: $main-color;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: $main-color;
    border-color: $main-color;
  }

  .form-check-label {
    font-size: 14px;
  }

  .form-control {
    border-radius: 0;
  }

  .boost-input input {
    margin: 0 10px;
    width: 20px;
    height: 20px;
  }
}
</style>
